import script from "./MoveActivityModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveActivityModal.vue?vue&type=script&setup=true&lang=js"

import "./MoveActivityModal.vue?vue&type=style&index=0&id=1c2c98fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2c98fa"]])

export default __exports__